// eslint-disable-next-line max-len
import { GetRequestsList, CreateS12ThresholdsRequest, CreateXMLTopologyRequest, DeleteRequest, UpdateRequest, VTKDataRefreshRequest, VTKDataRefreshEmailRequest } from '../requests/DataManagementRequests';

export const getRequestList = async () => {
	try {
		const response = await GetRequestsList(); // Faz a requisição
		return response.data; // Retorna apenas os dados
	} catch (error) {
		console.error('Error fetching requests:', error);
		throw error; // Lança o erro para ser tratado no componente
	}
};

export const deleteRequestAction = async (userId, name) => {
	try {
		const response = await DeleteRequest(userId, name); // Chama a requisição
		return response.data; // Retorna a resposta para o componente
	} catch (error) {
		console.error('Error deleting request:', error);
		throw error; // Lança o erro para ser tratado
	}
};

export const updateRequestAction = async (dto) => {
	try {
		const response = await UpdateRequest(dto); // Chama a requisição
		return response.data; // Retorna a resposta para o componente
	} catch (error) {
		console.error('Error updating request:', error);
		throw error; // Lança o erro para ser tratado
	}
};

export const CreateXMLTopologyAction = async (dto) => {
	try {
		const response = await CreateXMLTopologyRequest(dto); // Chama a requisição
		return response.data; // Retorna a resposta para o componente
	} catch (error) {
		throw error; // Lança o erro para ser tratado
	}
};

export const CreateS12ThresholdsAction = async (dto) => {
	try {
		const response = await CreateS12ThresholdsRequest(dto); // Chama a requisição
		return response.data; // Retorna a resposta para o componente
	} catch (error) {
		throw error; // Lança o erro para ser tratado
	}
};

export const VTKDataRefreshAction = async (dto) => {
	try {
		const response = await VTKDataRefreshRequest(dto); // Chama a requisição
		return response.data; // Retorna a resposta para o componente
	} catch (error) {
		throw error; // Lança o erro para ser tratado
	}
};

export const VTKDataRefreshEmailAction = async (dto) => {
	try {
		const response = await VTKDataRefreshEmailRequest(dto); // Chama a requisição
		return response.data; // Retorna a resposta para o componente
	} catch (error) {
		throw error; // Lança o erro para ser tratado
	}
};
